import { render, staticRenderFns } from "./insured-base-info-form.vue?vue&type=template&id=3740057e&scoped=true&"
import script from "./insured-base-info-form.vue?vue&type=script&lang=js&"
export * from "./insured-base-info-form.vue?vue&type=script&lang=js&"
import style0 from "./insured-base-info-form.vue?vue&type=style&index=0&id=3740057e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3740057e",
  null
  
)

export default component.exports